import * as tslib_1 from "tslib";
import { Component, Prop, PropSync, Ref, Vue } from "vue-property-decorator";
import Tree from "../../question/components/Tree.vue";
import { getPaperCategoryList } from "@/api/test-paper";
let TransferDialog = class TransferDialog extends Vue {
    constructor() {
        super(...arguments);
        this.currentSelected = null;
        this.btnLoading = false;
        this.treeData = [];
        this.isLoading = false;
        this.defaultCheckedKey = this.checkedId;
    }
    get fakeTreeData() {
        const treeData = this.treeData;
        return treeData.length > 0 && treeData[0].children.length > 0 ? treeData[0].children : [];
    }
    created() {
        this.handleGetLibraryData();
    }
    handleDialogOpen() {
        this.btnLoading = false;
        this.currentSelected = null;
    }
    handleTreeNodeClick(data, node) {
        this.currentSelected = data;
        this.defaultCheckedKey = '';
        this.$emit('node-click', this.currentSelected);
    }
    handleCheckedClasses() {
        let current = this.currentSelected;
        if (current === null) {
            const treeEl = this.tree.getTreeComponent();
            const node = treeEl.getNode(this.checkedId);
            if (!node)
                return this.$message.error('请选择试卷分类');
            current = node.data;
        }
        // console.log('current', current);
        const children = current.children;
        if (children && children.length > 0) {
            this.$message.error('不能修改至非最子分类!');
        }
        else {
            this.btnLoading = true;
            this.$emit('on-confirm', current);
        }
    }
    handleEditTransfer() {
        window.open('/#/data-manager/test-paper/');
    }
    refresh() {
        this.handleGetLibraryData();
    }
    async handleGetLibraryData() {
        try {
            this.isLoading = true;
            const { data } = await getPaperCategoryList();
            this.isLoading = false;
            this.treeData = data.data || [];
        }
        catch (_) { }
    }
};
tslib_1.__decorate([
    PropSync('visible', { type: Boolean, default: false })
], TransferDialog.prototype, "showDialog", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '修改分类' })
], TransferDialog.prototype, "title", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], TransferDialog.prototype, "checkedId", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], TransferDialog.prototype, "expandedId", void 0);
tslib_1.__decorate([
    Ref()
], TransferDialog.prototype, "tree", void 0);
TransferDialog = tslib_1.__decorate([
    Component({
        name: 'TransferDialog',
        components: {
            Tree
        },
    })
], TransferDialog);
export default TransferDialog;
